import { GET_CART, GET_SINGLE_CART, GET_SINGLE_WIX, GET_WIX } from "../../actions/type";

// activity intial state
const initialCart = {
    allCart: null,
    cartForEdit: null,
    isLoading: true,
    isEditLoading: true,
};

export const reducer = (state = initialCart, action) => {
    switch (action.type) {
        case GET_CART: {
            const allCart = action.payload;
            return {
                ...state,
                allCart: allCart,
                isLoading: false,
            };
        }
        case GET_SINGLE_CART: {
            const cartForEdit = action.payload;
            return {
                ...state,
                cartForEdit,
                isEditLoading: false,
            };
        }
        default:
            return state;
    }
};